const Footer = (props) => {
  const siteContent = props.siteContent;

  return (
    <footer className="footer">
      <div className="container">
        <p className="footer-copyright">
          © 2018-{new Date().getFullYear()} RPM ROLEPLAY. Копирование материалов
          запрещено.
        </p>
        <p className="footer-email">
          ИП ПЛУЖНИКОВ АЛЕКСЕЙ ЮРЬЕВИЧ (ИНН 772792256884 ОГРНИП 324774600080992)
        </p>
        <a
          href={"mailto:" + siteContent.contact_email}
          className="footer-email"
        >
          Для связи: {siteContent.contact_email}
        </a>
        <div className="footer-payments">
          <a
            href="/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
            onClick={(e) => e.preventDefault()}
          >
            <img
              src="/assets/images/payments/mastercard.svg"
              className="footer-payment__src"
              alt="MasterCard Accepted"
            />
          </a>
          <a
            href="/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
            onClick={(e) => e.preventDefault()}
          >
            <img
              src="/assets/images/payments/visa.svg"
              className="footer-payment__src"
              alt="Visa Accepted"
            />
          </a>
          <a
            href="/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
            onClick={(e) => e.preventDefault()}
          >
            <img
              src="/assets/images/payments/mir.svg"
              className="footer-payment__src"
              alt="Мир Accepted"
            />
          </a>
          <a
            href="/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
            onClick={(e) => e.preventDefault()}
          >
            <img
              src="/assets/images/payments/sbp.svg"
              className="footer-payment__src"
              alt="СБП Accepted"
            />
          </a>
        </div>
        <div className="footer-payments">
          {/* <a
            href="https://unitpay.ru/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
          >
            <img
              src="/assets/images/payments/unitpay.svg"
              className="footer-payment__src"
              alt="Приём оплаты через Unitpay"
            />
          </a> */}
          <a
            href="https://freekassa.ru/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="footer-payment"
          >
            <img
              src="/assets/images/payments/fk.svg"
              className="footer-payment__src"
              alt="Приём оплаты через FreeKassa"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
